import React, { useRef, useEffect } from 'react';
import { Animated, StyleSheet } from 'react-native';
import { FAB, useTheme } from 'react-native-paper';
import { ChevronUp } from 'lucide-react-native';

interface ScrollToTopFABProps {
  visible: boolean;
  onPress: () => void;
  testID?: string;
}

export function ScrollToTopFAB({
  visible,
  onPress,
  testID,
}: ScrollToTopFABProps) {
  const theme = useTheme();
  const scaleAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.spring(scaleAnim, {
      toValue: visible ? 1 : 0,
      useNativeDriver: true,
      tension: 100,
      friction: 8,
    }).start();
  }, [visible, scaleAnim]);

  if (!visible) return null;

  return (
    <Animated.View
      style={[
        styles.container,
        {
          transform: [{ scale: scaleAnim }],
        },
      ]}
    >
      <FAB
        icon={({ size }) => (
          <ChevronUp size={size} color={theme.colors.onPrimary} />
        )}
        size='small'
        style={[
          styles.fab,
          {
            backgroundColor: theme.colors.primary,
          },
        ]}
        onPress={onPress}
        testID={testID}
      />
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 24,
    right: 24,
    zIndex: 1000,
  },
  fab: {
    elevation: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,
  },
});
